import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import CategoryPage from './categorypage/categorypage';

function collectOriginalPromotionTileHtml(promotionTiles: { dynaDocKey: string }[]): Map<string, string> {
    const originalPromotionTileHtml = new Map<string, string>();
    promotionTiles?.forEach(tile => {
        const fragmentPlaceholders = document.querySelectorAll(
            `[data-tile-key="${tile.dynaDocKey}"] .fas_fragment_ph`);
        const dom = Array.from(fragmentPlaceholders).find(fragment => fragment.innerHTML);
        if (dom && dom.innerHTML) {
            originalPromotionTileHtml.set(tile.dynaDocKey, dom.innerHTML);
        }
    });
    return originalPromotionTileHtml;
}

function hydrateCategoryPage() {
    if (typeof window.__PRELOADED_CATEGORY_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_CATEGORY_PAGE_STATE__));
        delete window.__PRELOADED_CATEGORY_PAGE_STATE__;

        // must run before hydration, the placeholders are removed from the DOM later on
        const originalPromotionTileHtml = collectOriginalPromotionTileHtml(data.promotionTiles);

        hydrateRoot(
            document.getElementById('ats-categorypage'),
            <CategoryPage {...data} originalPromotionTileHtml={originalPromotionTileHtml} />,
        );
    }
}

hydrateCategoryPage();
